<div class="dropdown-select" ng-repeat="button in $ctrl.buttons track by $index">
    <button ng-if="button.type === $ctrl.buttonTypes.static" class="attachments-button" ng-click="$ctrl.actionShowDropdown(button)" ng-bind-html="button.buttonTextAndAngle"></button>
    <button ng-if="button.type === $ctrl.buttonTypes.upload" class="attachments-button">
        <c-drop-zone class="dropzone" id="button.id" max-files="button.maxFiles" files="button.items" message="button.text" auto="false" url="" headers="" one-drive="$ctrl.oneDriveEnabled"></c-drop-zone>
        <i class="fa fa-angle-down" ng-click="$ctrl.actionShowDropdown(button)"></i>
    </button>
    <ul ng-if="button.showDropdown">
        <li class="empty" ng-if="!button.items.length">{{button.texts.empty}}</li>
        <li ng-repeat="item in button.items track by $index">
            <span style="display: inline-flex">
                <span ng-if="item.action" ng-class="item.action.classes" ng-bind-html="item.action.button" ng-click="item.action.callback($event, item)"></span>
                <c-checkbox label="item.text" checked="item.checked" ng-click="$ctrl.itemClicked(button)"></c-checkbox>
            </span>
        </li>
    </ul>
</div>